'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import { stringify } from 'hub-http/helpers/params';
import { FLOW_COMPLETED, FLOW_CANCELED } from 'ui-addon-scriptloader/constants/MessageKeys';
import InstallTypes from 'ui-addon-scriptloader/constants/InstallTypes';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const getIframeSrc = (queryObj = {}) => {
  const domain = getFullUrl('app');
  const portalId = PortalIdParser.get();
  return `${domain}/script-loader-wizard/${portalId}/?${stringify(queryObj)}`;
};
class ScriptloaderInstallWizardIframe extends Component {
  constructor(props) {
    super(props);
    this.handleFrameMessage = this.handleFrameMessage.bind(this);
  }
  componentDidMount() {
    window.addEventListener('message', this.handleFrameMessage);
  }
  componentWillUnmount() {
    window.removeEventListener('message', this.handleFrameMessage);
  }
  handleFrameMessage(e) {
    const {
      onConfirm,
      onReject
    } = this.props;
    if (e.data === FLOW_COMPLETED) {
      onConfirm();
    } else if (e.data === FLOW_CANCELED) {
      onReject();
    }
  }
  render() {
    const {
      showStatus,
      installType,
      isInline
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "scriptloader-iframe-container",
      style: {
        height: '100%'
      },
      children: /*#__PURE__*/_jsx("iframe", {
        src: getIframeSrc({
          showStatus,
          installType,
          isInline
        }),
        frameBorder: "0",
        scrolling: "yes",
        marginHeight: "0",
        marginWidth: "0",
        width: "100%",
        style: {
          height: '100%'
        }
      })
    });
  }
}
ScriptloaderInstallWizardIframe.propTypes = {
  installType: PropTypes.oneOf(Object.values(InstallTypes)),
  isInline: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  showStatus: PropTypes.bool
};
ScriptloaderInstallWizardIframe.defaultProps = {
  isInline: false
};
export default ScriptloaderInstallWizardIframe;